import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { actions as servicePaymentsActions } from "reducers/servicePayments";

export const useBilling = () => {
    const { billingList, fetchingBilling, fetching: fetchingPrepare } = useSelector((state) => state.servicePayments);
    const dispatch = useDispatch();
    const hasBilling = billingList?.length > 0;

    const handleInvoices = (values) => {
        const form = Object.fromEntries(
            Object.entries(values).filter(
                ([key]) =>
                    !key.includes("companyCode") &&
                    !key.includes("paymentType") &&
                    !key.includes("debitAccountId") &&
                    !key.includes("amountField"),
            ),
        );

        if (form?.DF1) {
            form.DF1 = moment(form.DF1).format("YYYY-MM-DD");
        }

        const data = {
            companyCode: values.companyCode,
            paymentMode: values.paymentType,
            form,
        };
        dispatch(servicePaymentsActions.getServiceInvoices(data));
    };
    return { handleInvoices, billingList, fetchingBilling, fetchingPrepare, hasBilling };
};

export default useBilling;
